//同步
export const updateUser = object => ({
  type: 'UPDATE_USER',
  data: object,
});
